import React from 'react';
import Booking from '../wholesale/Booking';

/**
 * Platform Bookings — the same booking calendar the Wholesale suite uses,
 * scoped to the platform business (demo calls booked via /book/46).
 * Wrapped in a light panel so it stays readable inside the dark console.
 */
const BookingsPage: React.FC = () => (
  <>
    <div className="plat-header">
      <div>
        <h2>Demo Bookings</h2>
        <p>Calls booked through your public page — app.shahosuite.com/book/46. Click a booking to change time or status.</p>
      </div>
    </div>
    <div style={{ background: '#f8fafc', borderRadius: 14, border: '1px solid #1e293b', overflow: 'hidden' }}>
      <Booking />
    </div>
  </>
);

export default BookingsPage;
